export enum MeanTypeEnum {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  GOOGLE_AUTH = 'GOOGLE_AUTH',
}
